import { render, staticRenderFns } from "./cTable.vue?vue&type=template&id=fa494476&scoped=true&"
import script from "./cTable.vue?vue&type=script&lang=js&"
export * from "./cTable.vue?vue&type=script&lang=js&"
import style0 from "./cTable.vue?vue&type=style&index=0&id=fa494476&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa494476",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa494476')) {
      api.createRecord('fa494476', component.options)
    } else {
      api.reload('fa494476', component.options)
    }
    module.hot.accept("./cTable.vue?vue&type=template&id=fa494476&scoped=true&", function () {
      api.rerender('fa494476', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/charts/cTable.vue"
export default component.exports